export default "__VITE_ASSET__CHdi7bbB__"